
import {
	Component,
	Inject,
	OnInit,
	AfterViewInit,
	Input,
} from "@angular/core";
import { IColunasGrid, IMatrizRiscoControle, IMatrizRiscoControleRisco, IMatrizRiscoControleRiscosCalculo, IMatrizRiscoControleRiscosCausa, IMatrizRiscoControleRiscosConsequencia, IMatrizRiscoEscalaMagnitude } from "../../model/matriz-risco-controle.model";
import { IMaginitudesEscalaRisco } from "src/app/models/maginitudes-escala-risco.model";
import { EscalasService } from "src/app/services/escalas.service";
import { ICriteriosAvaliacaoRiscos } from "src/app/models/criterios-avaliacao-riscos.model";
import { CriteriosAvaliacaoRiscoService } from "src/app/services/criterios-avaliacao-risco.service";
import { FiltroCriterioAvaliacaoRiscos } from "src/app/models/filtro-criterio-avaliacao-riscos.model";
import Swal from "sweetalert2";
import { MagnitudesEscalaRiscoService } from "src/app/services/magnitudes-escala-risco.service";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
import { FormulaRiscoInerenteService } from "src/app/services/formula-risco-inerente.service";
import { NiveisRiscoInerenteService } from "src/app/services/niveis-risco-inerente.service";
import { IEscalas } from "src/app/models/escalas.model";
import { IRiscosModel } from "src/app/models/riscos.model";
import { RiscosService } from "src/app/services/riscos.service";
import { FiltroRisco } from "src/app/models/filtro-risco.model";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ModalCopiarRiscoComponent } from "./modal-copiar-risco/modal-copiar-risco.component";

@Component({
	selector: "app-mr-aba-riscos",
	templateUrl: "./mr-aba-riscos.component.html",
	styleUrls: ["./mr-aba-riscos.component.scss"],
})
export class MrAbaRiscosComponent extends BaseListComponent implements OnInit, AfterViewInit {
	@Input() objPrincipal!: IMatrizRiscoControle;
	@Input() visualizar: boolean;

	atividadeSelecionada!: number;

	listCriteriosRiscos: IRiscosModel[] = [];
	riscoSelecionado!: number;
	txtDescricaoRisco!: string;
	habNovoRisco: boolean = false;

	dataSource!: any;
	listColunas: IColunasGrid[] = [
		{ id: "posicao", label: "Ref" },
		{ id: "descricaoRisco", label: "Descrição" },
		{ id: "descricaoAtividade", label: "Atividade" }
	];

	txtCausa!: string;
	txtConsequencia!: string;
	txtRiscoInerente!: string;
	txtNivelRiscoInerente!: string;

	listCausa: IMatrizRiscoControleRiscosCausa[] = [];
	listCausaRemover: IMatrizRiscoControleRiscosCausa[] = [];

	listConsequencia: IMatrizRiscoControleRiscosConsequencia[] = [];
	listConsequenciaRemover: IMatrizRiscoControleRiscosConsequencia[] = [];

	listEscalas: IMatrizRiscoEscalaMagnitude[] = [];

	objEditar: IMatrizRiscoControleRisco = null;
	formulaRiscoInerente: any;
	niveisRiscoList: any[] = []
	listDadosFormula: any[] = []

	listEscalaMagnitude: any[] = [];

	controleRiscoSelecionado: number = 0;

	constructor(
		private matDialog: MatDialog,
		private escalaService: EscalasService,
		private magnitutesService: MagnitudesEscalaRiscoService,
		private riscoService: RiscosService,
		private formulaRiscoInerenteService: FormulaRiscoInerenteService,
		private niveisRiscoService: NiveisRiscoInerenteService
	) {
		super();
	}

	ngOnInit(): void {
		this.listCausaRemover = [];
		this.listConsequenciaRemover = [];

		this.carregaCriteriosRiscos();
	}

	ngAfterViewInit() {

	}

	setAtividade() {
		if (this.atividadeSelecionada == undefined || this.atividadeSelecionada == 0) {
			this.atividadeSelecionada = this.objPrincipal.atividades[0].controle;
		}
	}

	carregaFormulaCriterioRisco() {
		//console.log(this.objPrincipal);
		//console.log("carregaFormulaCriterioRisco");
		this.formulaRiscoInerenteService.obter(this.objPrincipal.idCriterioAvaliacao.toString(), true, true).then((res) => {
			//console.log(res?.dados[0]);
			this.formulaRiscoInerente = res?.dados[0];
			let dadosFormula = this.getDadosFormuma(this.listDadosFormula, JSON.parse(this.formulaRiscoInerente.dadosFormula))
			this.listDadosFormula = dadosFormula
			this.carregaNiveisRiscoPorCriterios();
		})
	}

	getDadosFormuma(escala: any[], dadosFormulaOld: any[]): any[] {
		return escala.map((item, index) => {
			if (index < dadosFormulaOld.length) {
				return { ...dadosFormulaOld[index] };
			}
			return item;
		});
	}

	carregaNiveisRiscoPorCriterios() {
		this.niveisRiscoService.obter(this.objPrincipal.idCriterioAvaliacao.toString(), true, true).then((res) => {
			this.niveisRiscoList = res.dados;
		})
	}

	carregaCriteriosRiscos() {
		let filtro = {} as FiltroRisco;
		filtro.ativo = true;
		filtro.pagina = 0;
		filtro.itensPorPagina = 0;
		this.riscoService.obter(filtro).then((res) => {
			this.listCriteriosRiscos = res.dados.resultado as IRiscosModel[];
		}).catch((err) => {
			this.exibirMensagemErro(err.mensagem);
		});
	}

	setListEscalas(dados: IEscalas[]) {
		this.listEscalas = [];
		for (let i = 0; i < dados.length; i++) {
			const element = dados[i];
			const novo: IMatrizRiscoEscalaMagnitude = {} as IMatrizRiscoEscalaMagnitude;
			novo.id = element.id;
			novo.listMagnitude = [];
			novo.idMagnitudeSelecionado = '0';
			novo.nome = element.nome;
			this.listEscalas.push(novo);
		}
	}

	carregaEscalas() {
		//("carregaEscalas");
		this.escalaService.obter(this.objPrincipal.idCriterioAvaliacao.toString(), true, true).then((res) => {
			//console.log(res?.dados);
			this.setListEscalas(res?.dados);
			for (let i = 0; i < this.listEscalas.length; i++) {
				this.listDadosFormula.push({ campo: '', operador: '' })

				const element = this.listEscalas[i];
				this.magnitutesService.obter(element.id as any, true, true).then((res) => {
					element.listMagnitude = [...res?.dados as IMaginitudesEscalaRisco[]];
				})
			}

			this.carregaFormulaCriterioRisco();
		})
	}

	getListEscalaMagnitude() {
		this.listEscalaMagnitude = [];

		for (let f = 0; f < this.listDadosFormula.length; f++) {
			const element = this.listDadosFormula[f];
			let campoEscala = this.listEscalas.find(f => f.nome == element.campo);
			if (campoEscala != undefined)
				this.listEscalaMagnitude.push({ idEscala: campoEscala.id, idMagnitude: Number(campoEscala.idMagnitudeSelecionado) });
		}
	}

	calculaRisco() {
		this.txtNivelRiscoInerente = "";
		this.txtRiscoInerente = "0";
		let listFormulaFinal = [];

		//console.log("this.listEscalas");
		//console.log(this.listEscalas);

		for (let f = 0; f < this.listDadosFormula.length; f++) {
			const element = this.listDadosFormula[f];

			let campoEscala = this.listEscalas.find(f => f.nome == element.campo);
			if (campoEscala != undefined) {
				//console.log("campoEscala");
				//console.log(campoEscala);
				let valorSelecionado = 0;
				let objSelecionado = campoEscala.listMagnitude.find(f => f.id === Number(campoEscala.idMagnitudeSelecionado));
				//console.log("objSelecionado");
				//console.log(objSelecionado);
				if (objSelecionado != undefined) {
					valorSelecionado = objSelecionado.valor;
					listFormulaFinal.push({
						valor: valorSelecionado,
						operador: element.operador
					});
				}
			}
		}

		let resultado = listFormulaFinal[0].valor;
		for (let i = 1; i < listFormulaFinal.length; i++) {
			/* O Operador esta sempre na posição anterior, por isso -1 */
			switch (listFormulaFinal[i - 1].operador) {
				case '+':
					resultado += listFormulaFinal[i].valor;
					break;
				case '-':
					resultado -= listFormulaFinal[i].valor;
					break;
				case '*':
					resultado *= listFormulaFinal[i].valor;
					break;
				case '/':
					if (listFormulaFinal[i].valor !== 0) {
						resultado /= listFormulaFinal[i].valor;
					} else {
						console.warn("Divisão por zero não permitida!");
					}
					break;
				default:
					console.warn(`Operador "${listFormulaFinal[i - 1].operador}" não reconhecido!`);
					return;
			}
		}

		for (const criterio of this.niveisRiscoList) {
			const valor = parseFloat(criterio.valor);
			const valor1 = criterio.valor_1 ? parseFloat(criterio.valor_1) : undefined;

			let condicao1 = false;
			let condicao2 = criterio.operador_1 && valor1 !== undefined ? false : true;

			switch (criterio.operador) {
				case "=":
					condicao1 = resultado === valor;
					break;
				case "!=":
					condicao1 = resultado !== valor;
					break;
				case ">":
					condicao1 = resultado > valor;
					break;
				case "<":
					condicao1 = resultado < valor;
					break;
				case ">=":
					condicao1 = resultado >= valor;
					break;
				case "<=":
					condicao1 = resultado <= valor;
					break;
			}

			if (criterio.operador_1 && valor1 !== undefined) {
				switch (criterio.operador_1) {
					case "=":
						condicao2 = resultado === valor1;
						break;
					case "!=":
						condicao2 = resultado !== valor1;
						break;
					case ">":
						condicao2 = resultado > valor1;
						break;
					case "<":
						condicao2 = resultado < valor1;
						break;
					case ">=":
						condicao2 = resultado >= valor1;
						break;
					case "<=":
						condicao2 = resultado <= valor1;
						break;
				}
			}

			if (condicao1 && condicao2) {
				this.txtNivelRiscoInerente = criterio.nome;
				this.txtRiscoInerente = resultado;
			}
		}
	}

	addCausa() {
		if (this.txtCausa.length < 10) {
			this.exibirMensagemAlerta("Informe uma descrição mínima de 10 caracteres!");
			return;
		}

		if (this.listCausa == null)
			this.listCausa = [];

		const novo: IMatrizRiscoControleRiscosCausa = {} as IMatrizRiscoControleRiscosCausa;
		novo.descricao = this.txtCausa;
		novo.controle = this.listCausa.length + 1;
		this.listCausa.push(novo);
		this.txtCausa = "";
	}

	removeCausa(item: IMatrizRiscoControleRiscosCausa) {
		if (item.id > 0) {
			this.listCausaRemover.push(this.listCausa.find(f => f.id === item.id));
			this.listCausa = this.listCausa.filter(f => f.id != item.id);
		}
		else
			this.listCausa = this.listCausa.filter(f => f.controle != item.controle);

	}

	addConsequencia() {
		if (this.txtConsequencia.length < 10) {
			this.exibirMensagemAlerta("Informe uma descrição mínima de 10 caracteres!");
			return;
		}

		if (this.listConsequencia == null)
			this.listConsequencia = [];

		const novo: IMatrizRiscoControleRiscosConsequencia = {} as IMatrizRiscoControleRiscosConsequencia;
		novo.descricao = this.txtConsequencia;
		novo.controle = this.listConsequencia.length + 1;
		this.listConsequencia.push(novo);
		this.txtConsequencia = "";
	}

	removeConsequencia(item: IMatrizRiscoControleRiscosConsequencia) {
		if (item.id > 0) {
			this.listConsequenciaRemover.push(this.listConsequencia.find(f => f.id === item.id));
			this.listConsequencia = this.listConsequencia.filter(f => f.id != item.id);
		}
		else
			this.listConsequencia = this.listConsequencia.filter(f => f.controle != item.controle);
	}

	remover(obj: IMatrizRiscoControleRisco) {

		if (this.objPrincipal.associados.length > 0) {
			if (this.objPrincipal.associados.some(s => s.controleRiscoControleRiscos == obj.controle)) {
				this.exibirMensagemAlerta("Não possível remover esse risco, ele esta sendo usado na aba Controle Associados!");
				return;
			}
		}

		if (obj.id > 0) {
			if (this.objPrincipal.riscosRemover == undefined)
				this.objPrincipal.riscosRemover = [];

			this.objPrincipal.riscosRemover.push(this.objPrincipal.riscos.find(f => f.id === obj.id));
			this.objPrincipal.riscos = this.objPrincipal.riscos.filter(f => f.id !== obj.id);
		}
		else
			this.objPrincipal.riscos = this.objPrincipal.riscos.filter(f => f.posicao !== obj.posicao);

		this.objPrincipal.riscos = [...this.objPrincipal.riscos];
	}

	adicionar() {
		if (this.atividadeSelecionada === 0) {
			this.exibirMensagemAlerta("Selecione a Atividade!");
			return;
		}

		//Quando tentar adicionar e tiver apenas 1 atividade, não setava o valorselecionado
		if (this.objPrincipal.atividades.length == 1) {
			this.atividadeSelecionada = this.objPrincipal.atividades[0].controle;
		}

		if (this.txtDescricaoRisco === "" && this.riscoSelecionado == undefined) {
			this.exibirMensagemAlerta("Selecione ou preencha o Risco Existente!");
			return;
		}

		if (this.txtNivelRiscoInerente == undefined || this.txtNivelRiscoInerente == "") {
			this.exibirMensagemAlerta("Risco Inerente não calculado!");
			return;
		}

		if (this.objPrincipal.riscos == null)
			this.objPrincipal.riscos = [];

		this.getListEscalaMagnitude();

		if (this.objEditar == null) {
			if (this.habNovoRisco) {
				if (this.objPrincipal.riscos.some(s => (s.descricaoRisco + "_" + s.controleAtividade === this.txtDescricaoRisco + "_" + this.atividadeSelecionada))) {
					this.exibirMensagemAlerta("Ja existe um Risco Identificado para essa atividade selecionada!");
					return;
				}
			}
			//Valida se ja tem uma atividade ja adicionada
			else {
				if (this.objPrincipal.riscos.some(s => (s.idRisco + "_" + s.controleAtividade) === (this.riscoSelecionado + "_" + this.atividadeSelecionada))) {
					this.exibirMensagemAlerta("Ja existe um Risco Identificado para essa atividade selecionada!");
					return;
				}
			}

			const nova: IMatrizRiscoControleRisco = {} as IMatrizRiscoControleRisco;
			nova.id = 0;
			nova.controleAtividade = this.atividadeSelecionada;
			nova.idRisco = this.riscoSelecionado;
			nova.descricaoRisco = this.txtDescricaoRisco;
			nova.descricaoAtividade = this.objPrincipal.atividades.find(f => f.controle == this.atividadeSelecionada).descricao;
			nova.causas = [...this.listCausa];
			nova.consequencias = [...this.listConsequencia];
			nova.resultadoRI = this.txtRiscoInerente;
			nova.nivelRI = this.txtNivelRiscoInerente;
			nova.calculos = [...this.listEscalaMagnitude]
			nova.posicao = this.objPrincipal.riscos.length + 1;
			nova.controle = this.objPrincipal.riscos.length + 1;
			this.objPrincipal.riscos.push(nova);
		}
		else {
			if (this.habNovoRisco) {
				if (this.objPrincipal.riscos.some(s => s => s.controle !== this.objEditar.controle
					&& (s.descricaoRisco + "_" + s.controleAtividade === this.txtDescricaoRisco + "_" + this.atividadeSelecionada))) {
					this.exibirMensagemAlerta("Ja existe um Risco Identificado para essa atividade selecionada!");
					return;
				}
			}
			//Valida se ja tem uma atividade ja adicionada
			else {
				if (this.objPrincipal.riscos.some(s => s.controle !== this.objEditar.controle
					&& ((s.idRisco + "_" + s.controleAtividade) === (this.riscoSelecionado + "_" + this.atividadeSelecionada)))) {
					this.exibirMensagemAlerta("Ja existe um Risco Identificado para essa atividade selecionada!");
					return;
				}
			}

			this.objEditar.controleAtividade = this.atividadeSelecionada;
			this.objEditar.idRisco = this.riscoSelecionado;
			this.objEditar.descricaoRisco = this.txtDescricaoRisco;
			this.objEditar.descricaoAtividade = this.objPrincipal.atividades.find(f => f.controle == this.atividadeSelecionada).descricao;
			this.objEditar.causas = [...this.listCausa];
			this.objEditar.consequencias = [...this.listConsequencia];
			this.objEditar.resultadoRI = this.txtRiscoInerente;
			this.objEditar.nivelRI = this.txtNivelRiscoInerente;
			this.objEditar.calculos = [...this.listEscalaMagnitude];
		}
		this.objPrincipal.riscos = [...this.objPrincipal.riscos];
		this.limpar();
	}

	limpar() {
		this.objEditar = null;
		this.atividadeSelecionada = this.objPrincipal.atividades[0].controle;
		this.riscoSelecionado = null;
		this.txtDescricaoRisco = "";
		this.habNovoRisco = false;

		this.txtCausa = "";
		this.listCausa = [];

		this.txtConsequencia = "";
		this.listConsequencia = [];

		this.listCausaRemover = [];
		this.listConsequenciaRemover = [];

		this.listEscalaMagnitude = [];
		for (let i = 0; i < this.listEscalas.length; i++) {
			const element = this.listEscalas[i];
			element.idMagnitudeSelecionado = '0';
		}

		this.txtRiscoInerente = "";
		this.txtNivelRiscoInerente = "";
	}

	editar(obj: IMatrizRiscoControleRisco) {
		this.objEditar = obj;

		this.atividadeSelecionada = obj.controleAtividade;
		this.riscoSelecionado = obj.idRisco;
		this.txtDescricaoRisco = obj.descricaoRisco;
		this.habNovoRisco = this.riscoSelecionado == 0;

		this.txtCausa = "";
		this.listCausa = [...obj.causas];

		this.txtConsequencia = "";
		this.listConsequencia = [...obj.consequencias];

		this.listCausaRemover = [];
		this.listConsequenciaRemover = [];

		for (let i = 0; i < this.listEscalas.length; i++) {
			const element = this.listEscalas[i];
			element.idMagnitudeSelecionado = obj.calculos.find(f => f.idEscala == element.id).idMagnitude;
		}
		this.calculaRisco();
	}

	changeRisco() {
		this.txtDescricaoRisco = "";

		if (this.listCriteriosRiscos != undefined && this.listCriteriosRiscos.length > 0 && this.riscoSelecionado > 0) {
			this.habNovoRisco = false;
			this.txtDescricaoRisco = this.listCriteriosRiscos.find(f => f.id == this.riscoSelecionado).nome;
		}
	}

	novo() {
		this.limpar();
	}

	getNameBtn() {
		if (this.objEditar == null)
			return "Adicionar";
		else
			return "Salvar";
	}

	novoRisco() {
		// this.riscoSelecionado = 0;
		this.habNovoRisco = true;
		this.txtDescricaoRisco = "";
	}

	copiarRisco() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.id = 'modal-copiar-risco';
		dialogConfig.width = '50%';
		dialogConfig.height = '20%';
		dialogConfig.hasBackdrop = true;
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			objPrincipal: this.objPrincipal
		};

		const modal = this.matDialog.open(
			ModalCopiarRiscoComponent,
			dialogConfig
		);

		modal.afterClosed().subscribe((data) => {
			if (data !== undefined) {
				this.clonarCausasConsequencias(data);
			}
		});
	}

	clonarCausasConsequencias(controleRiscoSelecionado: number) {
		if (this.objPrincipal.riscos !== undefined && this.objPrincipal.riscos.length > 0) {
			let objMesmoRisco = this.objPrincipal.riscos.find(f => f.controle == controleRiscoSelecionado);
			if (objMesmoRisco !== undefined) {
				//Carrega Causas de outro objeto do mesmo Risco selecionado				
				if (objMesmoRisco.causas !== undefined && objMesmoRisco.causas.length > 0) {

					objMesmoRisco.causas.forEach(item => {
						const existe = this.listCausa.some(dest => dest.descricao === item.descricao);
						if (!existe) {
							item.id = 0;
							this.listCausa.push(item);
						}
					});
				}

				//Carrega Consequencias de outro objeto do mesmo Risco selecionado
				if (objMesmoRisco.consequencias !== undefined && objMesmoRisco.consequencias.length > 0) {

					objMesmoRisco.consequencias.forEach(item => {
						const existe = this.listConsequencia.some(dest => dest.descricao === item.descricao);
						if (!existe) {
							item.id = 0;
							this.listConsequencia.push(item);
						}
					});
				}
			}
		}
	}

	importar(id : number): any {
		if (this.objPrincipal.atividades.length == 1) {
			this.atividadeSelecionada = this.objPrincipal.atividades[0].controle;
		}

		if (this.txtDescricaoRisco === "" && this.riscoSelecionado == undefined) {
			this.exibirMensagemAlerta("Selecione ou preencha o Risco Existente!");
			return;
		}

		if (this.txtNivelRiscoInerente == undefined || this.txtNivelRiscoInerente == "") {
			this.exibirMensagemAlerta("Risco Inerente não calculado!");
			return;
		}

		if (this.objPrincipal.riscos == null)
			this.objPrincipal.riscos = [];

		this.getListEscalaMagnitude();

		const nova: IMatrizRiscoControleRisco = {} as IMatrizRiscoControleRisco;
		nova.id = 0;
		nova.controleAtividade = this.atividadeSelecionada;
		nova.idRisco = this.riscoSelecionado;
		nova.descricaoRisco = this.txtDescricaoRisco;
		nova.descricaoAtividade = this.objPrincipal.atividades.find(f => f.controle == this.atividadeSelecionada).descricao;
		nova.causas = [...this.listCausa];
		nova.consequencias = [...this.listConsequencia];
		nova.resultadoRI = this.txtRiscoInerente;
		nova.nivelRI = this.txtNivelRiscoInerente;
		nova.calculos = [...this.listEscalaMagnitude]
		nova.posicao = this.objPrincipal.riscos.length + 1;
		nova.controle = id;
		this.objPrincipal.riscos.push(nova);

		this.objPrincipal.riscos = [...this.objPrincipal.riscos];
		this.limpar();

		return this.objPrincipal.riscos;
	}

}
